module.exports = __webpack_public_path__ + "img/img_2@2x.79d80044.svg";